
import { useEffect } from 'react'
import Select from 'react-select'
import { STPEnergyMPCNoDDLAPI, WTPPlantNameDDLAPI, WTPSumpNumberDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WTPSumpNumberDDL = (props) => {
    const { SumpNumber, setSumpNumber,PlantName, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WTP_PlantID: PlantName.ID,
            M_UserID: UserID,
            token: token,
        }
        // if (UnitType.ID) {
        dispatch(WTPSumpNumberDDLAPI({ data }))
        // }
    }, [IsPost,PlantName.ID])

    const { WTPSumpNumberData } = useSelector(state => state.WTPSumpNumberDDL)

    useEffect(() => {
        handleWTPSumpNumberDDL()
    }, [WTPSumpNumberData])

    const handleWTPSumpNumberDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPSumpNumberData && WTPSumpNumberData.table && WTPSumpNumberData.table.length > 0) {
            let list = WTPSumpNumberData.table.map((item, index) => ({
                value: item.m_wtP_SumpID,
                label: item.sumpNumber,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setSumpNumber({ ...SumpNumber, DDL: list })
        }
        else {
            setSumpNumber({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Sump Number</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: SumpNumber.ID, label: SumpNumber.Label }}
                onChange={(e) => {
                    e ?
                        setSumpNumber({ ...SumpNumber, ID: e.value, Label: e.label })
                        :
                        setSumpNumber({ ...SumpNumber, ID: 0, Label: "Select..." })

                }}
                options={SumpNumber.DDL}
            />
        </div>
    )
}